


































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';

@Component
export default class SessionArchiveDetails extends Vue {

    @Prop() resource!: any | null;
    @Prop() index!: number | null;

    public sessionArchiveDialog: boolean = false;

    @Watch('index')
    onIndexChange(value: number | null) {
        if ( value != null ) {
            this.sessionArchiveDialog = true;
        } else {
            this.sessionArchiveDialog = false;
        }
    }

    @Watch('sessionArchiveDialog')
    onDialogBoolChange(value: boolean) {
        if (!value) {
            this.$emit('update:index', null);
        }
    }

    public get sessionDetails() {
        return this.resource;
    }
}
